/**
 * Client side tracking utlity
 */

const { cacheHit } = require('./napkin');

const initTracking = (module, placementId) => {
    if (module && module.meta && module.meta.trackingList && Array.isArray(module.meta.trackingList)) {
        module.meta.trackingList.forEach((trackingMeta) => {
            if (trackingMeta && trackingMeta.eventAction) {
                // eslint-disable-next-line default-case
                switch (trackingMeta.eventAction) {
                    case 'CACHE_HIT': {
                        cacheHit(placementId);
                        break;
                    }
                }
            }
        });
    }
};

module.exports = {
    initTracking
};
